<template>
  <span>
    <v-btn icon small :color="color" @click="dialog = true" title="¿Cómo funciona la producción?">
      <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="620" scrollable>
      <v-card>
        <v-card-title class="headline font-weight-bold pb-0">
          <v-icon left color="deep-purple">mdi-information-outline</v-icon>
          ¿Cómo funciona la producción?
        </v-card-title>
        <v-card-subtitle class="pt-1">
          Flujo completo desde el pedido hasta el stock actualizado.
        </v-card-subtitle>

        <v-divider />

        <v-card-text class="pt-4 pb-2">
          <v-timeline dense clipped>

            <v-timeline-item color="deep-purple" icon="mdi-shopping-outline" fill-dot small>
              <div class="font-weight-bold body-2 mb-1">1. Pedidos de clientes</div>
              <div class="body-2">
                Los pedidos llegan desde <strong>Ventas → Órdenes de preparación</strong>.
                Asigná una prioridad a cada uno — cuanto menor el número, más urgente
                (prioridad 1 se corta primero). Sin número significa sin prioridad definida.
              </div>
            </v-timeline-item>

            <v-timeline-item color="blue darken-1" icon="mdi-clipboard-list-outline" fill-dot small>
              <div class="font-weight-bold body-2 mb-1">2. Plan de producción</div>
              <div class="body-2">
                El <strong>Plan</strong> consolida todos los pedidos pendientes y calcula
                cuántas placas hay que cortar de cada programa para cubrir el faltante de stock.
                Podés ajustar la cantidad antes de generar para cortar más o menos de lo sugerido.
              </div>
            </v-timeline-item>

            <v-timeline-item color="teal darken-1" icon="mdi-plus-circle-outline" fill-dot small>
              <div class="font-weight-bold body-2 mb-1">3. Generar órdenes</div>
              <div class="body-2">
                Al confirmar el plan se crean las <strong>órdenes de producción</strong> en estado
                Pendiente. Cada orden ya sabe para qué pedidos cubre ese corte — lo ves directo
                en la cola sin tener que buscar nada.
              </div>
            </v-timeline-item>

            <v-timeline-item color="orange darken-2" icon="mdi-saw-blade" fill-dot small>
              <div class="font-weight-bold body-2 mb-1">4. Cortar en la máquina</div>
              <div class="body-2">
                En la <strong>Cola</strong>, el operario toma la orden y la inicia en la máquina.
                El cronómetro arranca. La tarjeta muestra los pedidos que están siendo cubiertos
                con ese corte y la prioridad de cada uno.
              </div>
            </v-timeline-item>

            <v-timeline-item color="green darken-1" icon="mdi-flag-checkered" fill-dot small>
              <div class="font-weight-bold body-2 mb-1">5. Finalizar</div>
              <div class="body-2">
                Al finalizar el corte, el sistema descuenta los insumos del stock y suma las
                bandejas producidas. El próximo plan ya refleja el nuevo stock — si sobró
                algo, se tiene en cuenta automáticamente.
              </div>
            </v-timeline-item>

          </v-timeline>

          <v-divider class="my-4" />

          <div class="subtitle-2 font-weight-bold mb-3">Puntos clave</div>
          <v-row dense>
            <v-col v-for="tip in tips" :key="tip.text" cols="12" sm="6">
              <v-card outlined flat class="pa-3 d-flex" style="gap: 10px; min-height: 68px">
                <v-icon :color="tip.color" size="22" class="flex-shrink-0 mt-1">{{ tip.icon }}</v-icon>
                <div class="caption">{{ tip.text }}</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />
        <v-card-actions class="justify-end">
          <v-btn text color="deep-purple" @click="dialog = false">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'ProduccionAyuda',
  props: {
    color: { type: String, default: 'grey' },
  },
  data() {
    return {
      dialog: false,
      tips: [
        {
          icon: 'mdi-numeric-1-box-outline',
          color: 'deep-purple',
          text: 'Los chips #1, #2... en la cola indican la prioridad del pedido. Sin número = sin prioridad asignada.',
        },
        {
          icon: 'mdi-layers-outline',
          color: 'teal darken-1',
          text: 'Las recetas combinadas producen varios tipos de bandeja en un solo corte. El plan las prioriza cuando varios pedidos las necesitan.',
        },
        {
          icon: 'mdi-toggle-switch-outline',
          color: 'orange darken-2',
          text: 'Podés desactivar recetas desde Recetas para que el plan no las sugiera mientras no estén disponibles.',
        },
        {
          icon: 'mdi-chart-timeline-variant',
          color: 'blue darken-1',
          text: 'Si sobran bandejas después de un corte, el próximo plan las descuenta automáticamente del cálculo.',
        },
        {
          icon: 'mdi-package-variant',
          color: 'blue-grey',
          text: '"Cubre demanda de:" muestra pedidos pendientes (no listos ni cancelados) que necesitan el producto de ese corte. El stock producido es compartido.',
        },
      ],
    };
  },
};
</script>
